var uris = [
  [1, require("/opt/buildhome/repo/js/login/firstscreen/icons/invest/tesla.png?asset")],
  [2, require("/opt/buildhome/repo/js/login/firstscreen/icons/invest/tesla@2x.png?asset")],
  [3, require("/opt/buildhome/repo/js/login/firstscreen/icons/invest/tesla@3x.png?asset")]
];

module.exports = {
  get uri() {
    var ratio = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    for (var i = 0; i < uris.length; i++) {
      if (uris[i][0] >= ratio) return uris[i][1];
    }
    return uris[uris.length - 1][1];
  },
  width: 45,
  height: 44,
  toString: function () {
    return this.uri;
  },
};
